import { API } from './apiConstants';
/*
  errors: [{
    code: "",
    message: ""
  }]
*/
class ApiError extends Error {
  constructor({
    type,
    status,
    errors,
    genericMessage,
    response,
    innerError
  }) {
    super(status, errors, genericMessage);

    Object.assign(this, {
      name: 'ApiError',
      type: type || API.ERROR_TYPE.OTHER,
      status,
      genericMessage: genericMessage || 'Something went wrong',
      errors: errors || [],
      response,
      innerError 
    });
  }
}

export default ApiError;